const basePath = "enterprise-electronics-av/";

export const enterpriseElectronicsAV = {
  id: 14,
  category: "Enterprise Electronics & AV",

  filters: {
    Brand: { type: "checkbox" },
    Model: { type: "checkbox" },
    "Video Resolution": { type: "checkbox" },
    Connectivity: { type: "checkbox" },
    "Screen Size": { type: "checkbox" },
    Resolution: { type: "checkbox" },
    Lens: { type: "checkbox" },
    Type: { type: "checkbox" },
    Brightness: { type: "checkbox" },
    Size: { type: "checkbox" },
    Touch: { type: "checkbox" },
    Zoom: { type: "checkbox" },
    Compatibility: { type: "checkbox" },
    Inputs: { type: "checkbox" },
    Outputs: { type: "checkbox" },
  },

  subcategories: [
    {
      name: "Logitech Rally Plus Video Conferencing Kit",
      bestSeller: true,
      image: `${basePath}logitech-rally.jpeg`,
      details: {
        Brand: "Logitech",
        Model: "Rally Plus",
        "Video Resolution": "4K Ultra HD",
        Connectivity: "USB, HDMI",
      },
      about: `
        <ul>
          <li>Premium modular video conferencing system for large rooms.</li>
          <li>RightSound and RightLight technologies enhance meeting quality.</li>
        </ul>
      `,
    },
    {
      name: "Samsung QBR Series 55'' Digital Signage",
      bestSeller: true,
      image: `${basePath}samsung-qbr.jpg`,
      details: {
        Brand: "Samsung",
        Model: "QBR 55",
        "Screen Size": "55 Inches",
        Resolution: "4K UHD",
      },
      about: `
        <ul>
          <li>Bright and vivid 4K signage display with Crystal Processor 4K.</li>
          <li>Built-in MagicINFO player for content scheduling.</li>
        </ul>
      `,
    },
    {
      name: "Hikvision DS-2CD2T86G2 CCTV Camera",
      bestSeller: true,
      image: `${basePath}hikvision-cam.webp`,
      details: {
        Brand: "Hikvision",
        Model: "DS-2CD2T86G2",
        Resolution: "8 MP",
        Lens: "2.8 mm",
      },
      about: `
        <ul>
          <li>High-resolution outdoor IP camera with IR night vision.</li>
          <li>Built-in analytics and motion detection.</li>
        </ul>
      `,
    },
    {
      name: "Poly Studio X30 Video Bar",
      bestSeller: true,
      image: `${basePath}poly-x30.webp`,
      details: {
        Brand: "Poly",
        Model: "Studio X30",
        Resolution: "4K Ultra HD",
        Connectivity: "Wi-Fi, Bluetooth, HDMI",
      },
      about: `
        <ul>
          <li>All-in-one video bar for small to medium meeting rooms.</li>
          <li>Integrated Zoom and Microsoft Teams support.</li>
        </ul>
      `,
    },
    {
      name: "Business Projector",
      bestSeller: true,
      image: `${basePath}Business_Projector.svg`,
      details: {
        Type: "LCD/DLP/Laser",
        Resolution: "1080p / 4K options",
        Brightness: "3000-5000 lumens",
      },
      about: `
        <ul>
          <li>High-quality projection for presentations and meetings.</li>
          <li>Supports multiple input sources and wireless connectivity.</li>
        </ul>
      `,
    },
    {
      name: "Interactive Whiteboard",
      bestSeller: true,
      image: `${basePath}Interactive_Whiteboard.png`,
      details: {
        Size: "55-86 inches",
        Touch: "Multi-touch capacitive",
        Connectivity: "Wi-Fi / USB / HDMI",
      },
      about: `
        <ul>
          <li>Facilitates collaborative brainstorming and presentations.</li>
          <li>Compatible with most AV conferencing software.</li>
        </ul>
      `,
    },
    {
      name: "Video Conferencing Camera",
      bestSeller: true,
      image: `${basePath}Video_Conferencing_Camera.svg`,
      details: {
        Resolution: "1080p / 4K",
        Zoom: "Optical 10x-20x",
        Connectivity: "USB / HDMI / Network",
      },
      about: `
        <ul>
          <li>High-quality video capture for meetings and remote collaboration.</li>
          <li>Supports pan, tilt, and auto-framing features.</li>
        </ul>
      `,
    },
    {
      name: "Conference Microphone",
      bestSeller: true,
      image: `${basePath}Conference_Microphone.svg`,
      details: {
        Type: "Boundary / Tabletop / Wireless",
        Connectivity: "USB / XLR / Bluetooth",
      },
      about: `
        <ul>
          <li>Clear audio capture for meeting rooms and boardrooms.</li>
          <li>Supports multiple microphones in a single conference setup.</li>
        </ul>
      `,
    },
    {
      name: "Conference Room Speaker",
      bestSeller: true,
      image: `${basePath}Conference_Speaker.svg`,
      details: {
        Type: "Ceiling / Table / Soundbar",
        Connectivity: "Wired / Wireless",
      },
      about: `
        <ul>
          <li>Ensures high-fidelity sound for conference calls and presentations.</li>
          <li>Supports echo cancellation and integrated DSP.</li>
        </ul>
      `,
    },
    {
      name: "Wireless Presentation System",
      bestSeller: true,
      image: `${basePath}Wireless_Presentation_System.svg`,
      details: {
        Compatibility: "Windows, Mac, Android, iOS",
        Connectivity: "Wi-Fi / HDMI",
      },
      about: `
        <ul>
          <li>Wirelessly share content from multiple devices to a display.</li>
          <li>Supports secure enterprise environments and multiple users.</li>
        </ul>
      `,
    },
    {
      name: "Digital Signage Display",
      bestSeller: true,
      image: `${basePath}Digital_Signage_Display.svg`,
      details: {
        Size: "32-98 inches",
        Resolution: "Full HD / 4K",
        Connectivity: "HDMI / USB / Network",
      },
      about: `
        <ul>
          <li>Displays announcements, advertisements, or dashboards.</li>
          <li>Supports scheduling and remote management.</li>
        </ul>
      `,
    },
    {
      name: "Document Camera",
      bestSeller: false,
      image: `${basePath}Document_Camera.svg`,
      details: {
        Resolution: "1080p / 4K",
        Zoom: "Optical 10x",
        Connectivity: "USB / HDMI",
      },
      about: `
        <ul>
          <li>Ideal for sharing documents, books, or objects in meetings and classrooms.</li>
          <li>Supports real-time annotation and recording.</li>
        </ul>
      `,
    },
    {
      name: "Projection Screen",
      bestSeller: false,
      image: `${basePath}Projection_Screen.svg`,
      details: {
        Type: "Manual / Motorized",
        Size: "60-120 inches",
      },
      about: `
        <ul>
          <li>High-gain projection screens for sharp images.</li>
          <li>Suitable for conference rooms and auditoriums.</li>
        </ul>
      `,
    },
    {
      name: "AV Switcher / Matrix Switch",
      bestSeller: false,
      image: `${basePath}AV_Switcher.svg`,
      details: {
        Inputs: "HDMI, DisplayPort, VGA",
        Outputs: "HDMI, DisplayPort, Network",
      },
      about: `
        <ul>
          <li>Centralizes AV signal routing for multiple displays and devices.</li>
          <li>Supports live switching, scaling, and signal management.</li>
        </ul>
      `,
    },
  ],
};
